import React from "react"
import styled from "styled-components"
import { UserImage } from "../../atoms"

export interface IStoriesProps {
  name: string
  position: string
  story: React.ReactElement
  index?: number
  imgSrc?: string
  refChild?: any
  id?: string
  className?: any
}

const Wrapper = styled.div<{ isLastScrollItem: boolean; isFirstItem: boolean }>`
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
  width: 100%;
  scroll-snap-align: start;
  scroll-snap-stop: always;
  min-height: 100%;

  @media only screen and (max-width: 1024px) {
    min-height: 100%;
  }

  @media only screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    align-items: flex-start;
    justify-content: flex-start;
    scroll-snap-align: start;
  }

  .detail-section {
    display: flex;
  }

  h3,
  h4 {
    color: ${(props) => props.theme.sameBase};
  }

  h3 {
    font-family: Lato, sans-serif;
    font-weight: 700;
    font-size: 1.25rem;
    line-height: 34px;
    margin-bottom: 10px;
    color: #ffffffcc;

    @media only screen and (max-width: 500px) {
      font-size: 1.25rem;
      line-height: 22px;
      font-weight: 700;
      margin-bottom: 12px;
    }
  }

  h4 {
    font-family: Lato, sans-serif;
    font-weight: 700;
    font-size: 0.875rem;
    line-height: 24px;
    margin-bottom: 10px;
    color: #00b6b6;

    @media only screen and (max-width: 500px) {
      font-size: 0.875rem;
      line-height: 16px;
      font-weight: 500;
      margin-bottom: 12px;
    }
  }

  .info {
    ${(props) => props.theme.paragraphInfo}
    color: ${(props) => props?.theme?.whiteAlpha60};
    max-width: 778px;
    padding-right: 90px;
    text-align: justify;

    @media only screen and (max-width: 500px) {
      font-size: 0.75rem;
      line-height: 18px;
      text-align: left;
    }

    @media only screen and (max-width: 768px) {
      padding-right: 0px;
      padding-bottom: 30px;
    }
  }
  .second-parag {
    margin-top: 10px;
    @media only screen and (max-width: 768px) {
      margin-top: -25px;
    }
  }
`

const MainTitle = styled.p`
  ${(props) => props.theme.typography.sectionHeadline};
  line-height: 48px;
  font-size: 1.875rem;
  color: ${(props) => props.theme.sameBase};
  span {
    font-size: 30px;
    font-family: Montserrat, sans-serif;
    background: linear-gradient(87.75deg, #0058ee 100%, #36d7b7 80%);
    background-clip: text;
    /* stylelint-disable property-no-vendor-prefix */
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  margin-bottom: 20px;

  @media (max-width: 769px) {
    display: none;
  }
`

const MobileImageWrapper = styled.div`
  display: none;

  @media only screen and (max-width: 768px) {
    display: block;
    margin-bottom: 12px;
  }
`

const DesktopImageWrapper = styled.div`
  display: block;

  @media only screen and (max-width: 768px) {
    display: none;
  }
`

const SuccessTimelineComponent: React.FC<IStoriesProps> = ({
  name,
  position,
  story,
  index,
  imgSrc,
  refChild,
  id,
  className,
}) => {
  return (
    <Wrapper
      isLastScrollItem={index === 5 ? true : false}
      isFirstItem={index === 0 ? true : false}
      ref={refChild}
      id={id}
      className={className}
    >
      <div className={"info-section"}>
        <MainTitle>
          {"Success stories in "} <br />
          <span>{"Ready to Work"}</span>
        </MainTitle>
        <div className="detail-section">
          <div>
            <h3>{name}</h3>
            <h4>{position}</h4>
            <MobileImageWrapper>
              <UserImage imgageSrc={imgSrc} />
            </MobileImageWrapper>
            {story}
          </div>
          <DesktopImageWrapper>
            <UserImage imgageSrc={imgSrc} />
          </DesktopImageWrapper>
        </div>
      </div>
    </Wrapper>
  )
}

export { SuccessTimelineComponent }
